import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ICONS } from '@app/constants';
import type { IconsPopoverContentType } from '@app/pages/Tags/Tags.types';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export const IconsPopoverContent: IconsPopoverContentType = ({
  setSelectedIcon,
}) => {
  return (
    <div className="icons-container">
      {ICONS.map((icon) => {
        return (
          <div
            className="icon"
            onClick={() => setSelectedIcon(icon.code)}
            key={icon.code}
          >
            <FontAwesomeIcon icon={icon.code as IconProp} />
          </div>
        );
      })}
    </div>
  );
};
